import React from 'react';
import { Button, Typography } from 'antd';
import { Plus } from 'lucide-react';
import { WorkflowHeaderProps } from '@/interfaces/ICalendarWorkflows';

const { Title, Text } = Typography;

export const WorkflowHeader: React.FC<WorkflowHeaderProps> = ({
	hasAnyBookingWorkflows,
	onAddNewWorkflow,
}) => {
	if (!hasAnyBookingWorkflows) {
		return null;
	}

	return (
		<div className="flex items-center justify-between mb-6">
			<div>
				<Title level={3} className="mb-2">
					Book Appointments
				</Title>
				<Text type="secondary">Manage how your AI handles appointment scheduling</Text>
			</div>
			<Button type="primary" icon={<Plus size={16} />} onClick={onAddNewWorkflow}>
				Add New Workflow
			</Button>
		</div>
	);
};
